import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _path2, _path3;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgJumia = function SvgJumia(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "m13.41 21.48-5.488 7.688M16.898 23.131l-2.773 3.63M10.744 18.956 8.03 22.509",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      strokeLinecap: "round"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M19.628 20.732a7.45 7.45 0 1 0 0-14.9 7.45 7.45 0 0 0 0 14.9Z",
      stroke: "currentColor",
      strokeWidth: 2
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      d: "M19.619 9.957a.01.01 0 0 1 .018 0l1.075 2.177a.01.01 0 0 0 .007.005l2.404.35a.01.01 0 0 1 .005.017l-1.738 1.695a.01.01 0 0 0-.003.01l.41 2.394a.01.01 0 0 1-.014.01l-2.15-1.13a.01.01 0 0 0-.01 0l-2.15 1.13a.01.01 0 0 1-.014-.01l.411-2.395a.01.01 0 0 0-.003-.009l-1.74-1.695a.01.01 0 0 1 .006-.017l2.403-.35a.01.01 0 0 0 .008-.005l1.075-2.177Z",
      stroke: "currentColor",
      strokeWidth: 1.5
    }))]
  }));
};
export default SvgJumia;